import React, { useContext, useEffect, useState } from 'react'
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { Button, Container, FormHelperText, Grid, TextField, Typography } from "@mui/material";
import { useNavigate } from 'react-router-dom';
import RtlProvider from '../../../Components/RtlProvider';
import { ContextNotification, severitys } from '../../../App';
import helper from '../../../helper';
import hotelApi from '../../../api/hotelApi';

import cityApi from '../../../api/cityApi';
import companyApi from '../../../api/companyApi';

import { RHFAutocomplete } from '../../../Components/RHFAutocomplete';
import { RHFAutocompleteMultiple } from '../../../Components/RHFAutocompleteMultiple';
import staticVariablesApi from '../../../api/staticVariablesApi';
import BeatLoading from '../../../Components/Loader/BeatLoader';


const AddHotel = () => {
  const { open, setOpen } = useContext(ContextNotification);
  const [Cities, SetCities] = useState([]);
  const [Regions, SetRegions] = useState([]);
  const [Companies, SetCompanies] = useState([])
  const [PriceGroups, SetPriceGroups] = useState([])
  const [submitLoading, setSubmitLoading] = useState(false);
  const navigate = useNavigate();
  const schema = yup.object().shape({
    Name: yup.string().required("نام هتل را وارد نمایید"),
    CityConsistency: yup.string().required("شهر را انتخاب نمایید"),
    Region: yup.string().required("منطقه را انتخاب نمایید"),
    PriceGroup: yup.string().required("گروه قیمتی الزامی است"),
    ImageFile64: yup.mixed()
      .test("fileType", "فرمت های مجاز pdf,jpeg,jpg,png", (files) => {
        let valid = true
        for (let index = 0; index < files.length; index++) {
          const element = files[index];
          if (element.type !== "image/jpeg" && element.type !== "image/png" && element.type !== "image/jpg" && element.type !== "application/pdf") {
            valid = false;
          }
        }
        return valid;
      })

  });
  const { register, handleSubmit, formState: { errors }, control, setValue } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmit = (data) => {
    setSubmitLoading(true);
    const formData = new FormData();
    formData.append("Name", data.Name);
    formData.append("Address", data.Address);
    formData.append("CityConsistency", data.CityConsistency);
    formData.append("Description", data.Description);
    formData.append("Region", data.Region);
    formData.append("ManagerName", data.ManagerName);
    formData.append("managerPhoneNumber", data.managerPhoneNumber);
    var dict = {};
    for (let index = 0; index < data.CompanyCode?.length; index++) {
      const element = data.CompanyCode[index];
      dict[element.id] = element.label;
    }

    formData.append("CompanyInfo", JSON.stringify(dict))
    formData.append("PriceGroup", data.PriceGroup);
    formData.append("PhoneNumber", data.PhoneNumber);
    formData.append("ArabianAddress", data.ArabianAddress);

    for (let index = 0; index < data.ImageFile64.length; index++) {
      const element = data.ImageFile64[index];
      formData.append("ImageFile64", element)
    }
    hotelApi.Add(formData)
      .then((res) => {
        if (res.data.success) {
          setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.success });
          navigate("/dashboard/HotelPanel");
        }
        else {
          setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.error });
        }
      }).catch(err => {
        if (err.response) {
          setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
        }
      }
      ).finally(() => { setSubmitLoading(false); });
  };

  useEffect(() => {
    GetCityDropDown();
    GetRegionDropDown();
    GetCompanyDropDown();
    GetPriceGroupDropDown();
  }, []);


  const GetRegionDropDown = () => {
    staticVariablesApi.GetRegionDropDown()
      .then((res) => {
        const arr = helper.DictionayToList(res.data.data);
        SetRegions(arr.map((item) => {
          return {
            id: item.key,
            label: item.value
          };
        }))
      })
      .catch((error) => console.log(error));
  };

  const GetCityDropDown = () => {
    staticVariablesApi.GetArabicCityConsistencyDropDown()
      .then((res) => {
        const arr = helper.DictionayToList(res.data.data)
        const mappedReponse = arr.map((r) => {
          return {
            id: r.key,
            label: r.value
          };
        });
        SetCities(mappedReponse);
      })
      .catch((error) => console.log(error));
  };

  const GetCompanyDropDown = () => {
    companyApi.CompanyCodeDropDown()
      .then((res) => {
        const arr = helper.DictionayToList(res.data.data);
        SetCompanies(arr.map((item) => {
          return {
            id: item.key,
            label: item.value
          };
        }))
      })
      .catch((error) => console.log(error));
  };
  const GetPriceGroupDropDown = () => {
    staticVariablesApi.GetPriceGroupDropDown()
      .then((res) => {
        const arr = helper.DictionayToList(res.data.data);
        SetPriceGroups(arr.map((item) => {
          return {
            id: item.key,
            label: item.value
          };
        }))
      })
      .catch((error) => console.log(error));
  }
  const handleRegionChanged = (id) => { };
  const handleCityChanged = (id) => { };
  const handleCompanyChanged = (arr) => {
  };
  const handlePriceGroupChanged = (id) => { }
  return (
    <Container component="main" maxWidth="xs">
      <form onSubmit={handleSubmit(onSubmit)}>
        <RtlProvider>
          <Typography component="h1" variant="h5" mb={2}>
            افزودن هتل
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField id="outlined-basic" variant="outlined" {...register("Name")} fullWidth label="نام" error={!!errors?.Name}
                helperText={errors?.Name?.message} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField id="outlined-basic" variant="outlined" {...register("PhoneNumber")} fullWidth label="تلفن هتل" error={!!errors?.PhoneNumber}
                helperText={errors?.PhoneNumber?.message} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField id="outlined-basic" variant="outlined" {...register("ManagerName")} fullWidth label="نام مدیر" error={!!errors?.ManagerName}
                helperText={errors?.ManagerName?.message} />

            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField id="outlined-basic" variant="outlined" {...register("managerPhoneNumber")} fullWidth label="تلفن مدیر هتل" error={!!errors?.managerPhoneNumber}
                helperText={errors?.managerPhoneNumber?.message} />
            </Grid>
            <Grid item xs={12}>
              <TextField multiline id="outlined-basic" variant="outlined" {...register("Address")} fullWidth label="آدرس فارسی" error={!!errors?.Address}
                helperText={errors?.Address?.message} />
            </Grid>
            <Grid item xs={12}>
              <TextField multiline id="outlined-basic" variant="outlined" {...register("ArabianAddress")} fullWidth label="آدرس عربی" error={!!errors?.ArabianAddress}
                helperText={errors?.ArabianAddress?.message} />

            </Grid>
            <Grid item xs={12}>
              <TextField multiline id="outlined-basic" variant="outlined" {...register("Description")} fullWidth label="توضیحات" error={!!errors?.Description}
                helperText={errors?.Description?.message} />


            </Grid>
            <Grid item xs={12} sm={6}>
              <RHFAutocomplete
                control={control}
                options={Regions ?? []}
                name="Region"
                placeholder="منطقه"
                onChange={handleRegionChanged}
                style={{
                  border: "none",
                  padding: 0
                }}
                error={!!errors?.Region}
                helperText={errors?.Region?.message}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <RHFAutocomplete
                control={control}
                options={Cities ?? []}
                name="CityConsistency"
                placeholder="شهر"
                onChange={handleCityChanged}
                style={{
                  border: "none",
                  padding: 0
                }}
                error={!!errors?.CityConsistency}
                helperText={errors?.CityConsistency?.message}
              />
            </Grid>
            <Grid item xs={12}>
              <RHFAutocompleteMultiple

                control={control}
                options={Companies ?? []}
                name="CompanyCode"
                placeholder="شرکت عربی"
                onChange={handleCompanyChanged}
                style={{
                  border: "none",
                  padding: 0
                }}
                defaultValue={[]}

              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <RHFAutocomplete
                control={control}
                options={PriceGroups ?? []}
                name="PriceGroup"
                placeholder="گروه قیمتی"
                onChange={handlePriceGroupChanged}
                style={{
                  border: "none",
                  padding: 0
                }}
                error={!!errors?.PriceGroup}
                helperText={errors?.PriceGroup?.message}
              />
            </Grid>
            <Grid item xs={12}>
              <input type="file" multiple {...register("ImageFile64")} />
              <FormHelperText error={!!errors?.ImageFile64}>{errors.ImageFile64?.message}</FormHelperText>
            </Grid>
            <Grid item xs={12}>
              <Button type="submit" variant="contained" color="secondary" disabled={submitLoading}><BeatLoading loading={submitLoading} color={"#e65100"} size={8} />افزودن</Button>
            </Grid>
          </Grid>


        </RtlProvider>
      </form>
    </Container>
  )
}
export default AddHotel;